// https://litepicker.com/docs/options

const { default: Litepicker } = require("litepicker");
const flatpickr = require("flatpickr");
const { Portuguese } = require("flatpickr/dist/l10n/pt.js");
const { active } = require("sortablejs");

const Datepicker = function () {

    const start = function () {

        let today = new Date().toISOString().slice(0, 10);

        new Litepicker({
            element: document.getElementById('litepicker'),
            singleMode: false,
            maxDate: today,
            // maxDays: 90,
            tooltipText: {
                one: 'dias',
                other: 'dias'
            },
            format: "DD/MM/YYYY",
            firstDay: 0,
            lang: "pt-BR"
        });
    }

    const datePickerRangeCustom = function () {

        $(document).on('click', '#endDTRange', function () {
            if ($('#startDTRange').val() == '') {
                alert('Selecione uma data inicial antes');
                $("#startDTRange").focus();
            }
        })

        $(".datepickerRangeCustom").datepicker({
            changeMonth: true,
            changeYear: true,
            minDate: new Date(1990, 1 - 1, 1),
            format: "dd/mm/yyyy",
            autoclose: true,

        }).on('changeDate', function (e) {

            var specificDate = moment($(this).val(), "DD/MM/YYYY");
            var formatted = specificDate.format("YYYY-MM-DD");


            if ($(this).attr('id') == 'startDTRange') {

                let data = e.date;

                // Último dia do mês
                let ultimoDia = new Date(
                    data.getFullYear(),
                    data.getMonth() + 1,
                    0
                );

                // Atualiza o datepicker com a nova data
                $('#endDTRange').datepicker('setDate', ultimoDia);
                $("#dtInitial").val(formatted);


            }
            if ($(this).attr('id') == 'endDTRange') {

                // verificando se segunda data é maior que a primeiroa
                let dataInicio = $('#startDTRange').datepicker('getDate');
                let dataFim = $('#endDTRange').datepicker('getDate');

                let inicio = moment(dataInicio);
                let fim = moment(dataFim);

                if (fim.isAfter(inicio)) {
                    $("#dtEnd").val(formatted);
                } else {
                    alert('Atenção!, a data final está menor que a inicial');
                    return;
                }

            }

        });



    }

    function getDateRange(option) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let startDate, endDate;

        switch (option) {

            case 'today':
                startDate = new Date(today);
                endDate = new Date(today);
                break;

            case 'yesterday':
                startDate = new Date(today);
                startDate.setDate(startDate.getDate() - 1);
                endDate = new Date(startDate);
                break;

            case 'this_week': {
                const day = today.getDay() || 7; // domingo = 7
                startDate = new Date(today);
                startDate.setDate(today.getDate() - (day - 1));
                endDate = new Date(today);
                break;
            }

            case 'last_week': {
                const day = today.getDay() || 7;
                startDate = new Date(today);
                startDate.setDate(today.getDate() - day - 6);
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 6);
                break;
            }

            case 'this_month':
                startDate = new Date(today.getFullYear(), today.getMonth(), 1);
                endDate = new Date(today);
                break;

            case 'last_month':
                startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                endDate = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case 'this_year':
                startDate = new Date(new Date().getFullYear(), 0, 1);
                endDate = new Date(new Date().getFullYear(), 11, 31);
                break;

            default:
                throw new Error('Opção inválida');
        }

        return {
            startDate,
            endDate,
            // startDateISO: formatDate(startDate),
            // endDateISO: formatDate(endDate)
            startDateISO: startDate.toISOString().split('T')[0],
            endDateISO: endDate.toISOString().split('T')[0],
        };
    }

    function selectRange(elm) {
        const range = getDateRange(elm.attr('dataRange'));
        console.log(range.startDateISO, range.endDateISO);

        $("#dtInitial").val(range.startDateISO);
        $("#dtEnd").val(range.endDateISO);
        $("#input-change-funil").val(elm.attr('dataRange'));

        textFlatPickerUpdate(elm.attr('dataRangePt'), elm);
        dropdownFlatPickerClose();
    }

    function initFlatPicker () {

        $(".inputCustomFlatpickr").each(function(i){
            const _this = $(this);
            _this.flatpickr({
                locale: Portuguese,
                mode: "range",
                altInput: true,
                dateFormat: "YYYY-MM-DD",
                altFormat: "DD/MM/YYYY",
                // allowInput: true,
                disableMobile: true,
                parseDate: (datestr, format) => {
                    return moment(datestr, format, true).toDate();
                },
                formatDate: (date, format, locale) => {
                    // locale can also be used
                    return moment(date).format(format);
                },
                onChange: function(selectedDates, dateStr, instance) {
                    
                    if (selectedDates.length === 2) {
                        const startDate = selectedDates[0];
                        const endDate = selectedDates[1];
    
                        const startStr = instance.formatDate(startDate, "Y-MM-DD");
                        const endStr = instance.formatDate(endDate, "Y-MM-DD");
                        
                        const startStrPt = instance.formatDate(startDate, "DD/MM/Y");
                        const endStrPt = instance.formatDate(endDate, "DD/MM/Y");
    
                        // quando houver segundp campo de comparação
                        if($(_this).hasClass('inputCustomFlatpickr-end')){
                            $("#dtInitial-comp").val(startStr);
                            $("#dtEnd-comp").val(endStr);
                            $("#input-change-funil-comp").val("custom");
                        } else{
                            $("#dtInitial").val(startStr);
                            $("#dtEnd").val(endStr);
                            $("#input-change-funil").val("custom");
                        }

                        //verifica se tem atribut exibindo fomrato data
                        if(_this.is('[data-format]')){
                            if(_this.attr('data-format') == 'dd/mm/yyyy - dd/mm/yyyy'){
                                _this.val(`${startStrPt} - ${endStrPt}`);
                                // console.log(_this.val(`${startStrPt} - ${endStrPt}`));
                            }
                        }
    
                        textFlatPickerUpdate(`${startStrPt} à ${endStrPt}`, _this);
                        dropdownFlatPickerClose();
    
                    }
    
                },
            });
        });
    }

    function dropdownFlatPicker (e) {
        
        const _this = $(e.currentTarget);
        _this.parent().addClass('active');

    }
    function dropdownFlatPickerClose(){
        $('.dropdownFlatPicker').removeClass('active');
    }
    function textFlatPickerUpdate(str, elm){
        if($(elm).closest('.dropdownFlatPicker').find('.btn-flatpicker-text').length > 0){
            $(elm).closest('.dropdownFlatPicker').find('.btn-flatpicker-text').text(str);
        }
    }

    return {
        init: function () {
            if ($('#litepicker').length > 0) {
                start();
            }
            $(document).on('click', '.selectRange', function(){
                $(this).parent().find('.selectRange').removeClass('active');
                $(this).addClass('active');
                selectRange($(this));
            });

            $(document).on('click', '.btn-flatpicker', dropdownFlatPicker);

            $(window).on('load', function() {
                if ($('.inputCustomFlatpickr').length > 0) {
                    console.log('inputCustomFlatpickr loaded');
                    initFlatPicker();
                }
            });

            // close datepicker click out
            $(document).on('click', function(e) 
            {
                var container = $(".dropdownFlatPicker");
                if (!container.is(e.target) && container.has(e.target).length === 0) 
                {
                    container.removeClass('active');
                }
            });
            
        }
    }
}();

module.exports = Datepicker;